import { Recurring } from '../graphql'

export const formatAmount = (cents: number | undefined): string | undefined => {
  if (!cents) return undefined
  return (cents / 100).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
  })
}

export const formatInterval = (recurring: Recurring | null | undefined): string | undefined => {
  if (!recurring || !recurring?.interval || !recurring?.intervalCount) {
    return undefined
  }

  const { interval, intervalCount } = recurring
  let retStr = ''

  if (intervalCount > 1) {
    retStr += `${intervalCount} ${interval}s`
  } else {
    retStr += `${interval}`
  }

  return retStr
}
